import { ISidebarLink, ISidebar } from './sidebar';

// icons
import { GiChart, GiStack, GiThreeBurningBalls } from 'react-icons/gi';
import { MdDashboard } from 'react-icons/md';
import { FaGamepad, FaUsers } from 'react-icons/fa';
import { BsArrowsCollapse } from 'react-icons/bs';
import { ImStatsBars } from 'react-icons/im';
import { AiFillSetting } from 'react-icons/ai';
import { IoMdNotificationsOutline } from 'react-icons/io';
import { FaTelegramPlane } from 'react-icons/fa';
import BallotIcon from '@mui/icons-material/Ballot';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export const gameTypeSidebar: ISidebarLink[] = [
  {
    title: 'Bets',
    icon: GiStack,
    path: 'bets',
    iconFontSize: 22,
  },
  {
    title: 'Results',
    icon: GiThreeBurningBalls,
    path: 'game-results',
    iconFontSize: 22,
  },
  {
    title: 'Limits',
    icon: BsArrowsCollapse,
    path: 'game-limits',
    iconFontSize: 22,
  },
  {
    title: 'Operation Stats',
    icon: ImStatsBars,
    path: 'operation-stats',
    iconFontSize: 22,
  },
  {
    title: 'Reports',
    icon: GiChart,
    path: 'reports',
    iconFontSize: 22,
  },
  {
    title: 'Operators Report',
    icon: GiChart,
    path: 'operators-report',
    iconFontSize: 22,
  },
  {
    title: 'Server Config',
    icon: AiFillSetting,
    path: 'server-config',
    iconFontSize: 22,
  },
];

export const adminSidebar: ISidebar[] = [
  {
    title: 'Management Dashboards',
    routes: [
      {
        title: 'Overview',
        icon: MdDashboard,
        path: 'overview',
        iconFontSize: 22,
      },
      {
        title: 'Usher',
        icon: FaUsers,
        path: 'usher',
        iconFontSize: 22,
      },
      {
        title: 'Players',
        icon: FaUsers,
        path: 'players',
        iconFontSize: 22,
      },
      {
        title: 'Cash & Chips',
        icon: FaUsers,
        path: 'cash-and-chips',
        iconFontSize: 22,
      },
      // {
      //   title: 'Operator',
      //   icon: FaUsers,
      //   path: 'coordinators',
      //   iconFontSize: 22,
      // },
      {
        title: 'Auditors',
        icon: FaUsers,
        path: 'auditors',
        iconFontSize: 22,
      },
      {
        title: 'Draw Admin',
        icon: FaUsers,
        path: 'draw-admins',
        iconFontSize: 22,
      },
    ],
  },
  {
    title: 'Game-Type Dashboard',
    routes: gameTypeSidebar,
  },
  {
    title: 'Admin Dashboards',
    routes: [
      {
        title: 'Games',
        icon: FaGamepad,
        path: 'game-types',
        iconFontSize: 22,
      },
      {
        title: 'Notifications',
        icon: IoMdNotificationsOutline,
        path: 'notifications',
        iconFontSize: 22,
      },
      {
        title: 'Telegram Report',
        icon: FaTelegramPlane,
        path: 'telegram-report',
        iconFontSize: 22,
      },
    ],
  },
];

export const cashierSidebar: ISidebar[] = [
  {
    title: 'Menus',
    routes: [
      {
        title: 'Cash In & Cash Out',
        icon: BallotIcon,
        path: 'pending-transactions',
        iconFontSize: 22,
      },
      {
        title: 'Player Transactions',
        icon: ReceiptLongIcon,
        path: 'player-transactions',
        iconFontSize: 22,
      },
      {
        title: 'Admin Cash Transactions',
        icon: PriceChangeIcon,
        path: 'admin-cash-transactions',
        iconFontSize: 22,
      },
      {
        title: 'Profit Loss Transactions',
        icon: PlaylistAddCheckIcon,
        path: 'profit-loss-transactions',
        iconFontSize: 22,
      },
    ],
  },
];

export const auditorSidebar: ISidebar[] = [
  {
    title: 'Menus',
    routes: [
      {
        title: 'Cash In & Cash Out',
        icon: BallotIcon,
        path: 'pending-transactions',
        iconFontSize: 22,
      },
      {
        title: 'Transaction History',
        icon: ReceiptLongIcon,
        path: 'transactions-history',
        iconFontSize: 22,
      },
    ],
  },
];
